import { gql } from './gql'

/**
 * The storefront-wide promotions — order-level offers like "15% off over
 * $1,000", not the per-product badges the catalog carries. These are what the
 * home's reels are built from; an empty list means there are no reels and no
 * way into them.
 *
 * The selection is the reel's whole vocabulary: `name` and `description` are
 * the tile and its body, `code` identifies it, `priority` orders them. `label`
 * and `customFields` are selected because the API offers them and a later reel
 * design may want them, not because anything reads them yet.
 */
export const GET_TOTAL_PROMOTIONS = gql`
  query Promotions(
    $storefrontName: String!
    $sessionUid: ID!
  ) {
    getTotalPromotions(storefrontName: $storefrontName, sessionUid: $sessionUid) {
      id
      code
      name
      label
      description
      type
      priority
      isActive
      customFields
    }
  }
`
